<template>
  <section class="answers-content">
    <div
      v-for="question in survey.selectedQuestions"
      :key="question"
      :class="`answers-box-${question}`"
      class="d-inline"
    >
      <label class="mb-1 d-block box-question">
        {{ survey.selectedSurvey.filter(qst => qst.id === question)[0].name }}
      </label>
      <selected-answers
        :options="survey.selectedAnswers.filter(ans => ans.questionId === question)"
        :options-key="question"
        @removeAnswer="removeAnswer"
      />
      <hr
        v-if="survey.selectedQuestions.indexOf(question) < survey.selectedQuestions.length - 1"
        class="mx-0"
      >
    </div>
  </section>
</template>

<script>
import { ref } from '@vue/composition-api'
import SelectedAnswers from './SelectedAnswers.vue'

export default {
  components: { SelectedAnswers },
  props: {
    // eslint-disable-next-line vue/require-default-prop
    survey: {
      type: [Array, Object],
    },
    // eslint-disable-next-line vue/require-default-prop
    surveyTargeting: {
      type: [Array, Object],
    },
  },
  setup(props) {
    const surveyTemporaryArr = ref([])
    const removeAnswer = (answer, id = props.survey.id) => {
      props.surveyTargeting.forEach(element => {
        if (element.id === id) {
          const answerIndex = element.selectedAnswers.indexOf(answer)
          element.selectedAnswers.splice(answerIndex, 1)
          if (surveyTemporaryArr.value.includes(answer)) {
            const index = surveyTemporaryArr.value.indexOf(answer)
            surveyTemporaryArr.value.splice(index, 1)
          }
          if (!element.selectedAnswers.some(a => a.questionId === answer.questionId)) {
            const questionIndex = element.selectedQuestions.indexOf(answer.questionId)
            element.selectedQuestions.splice(questionIndex, 1)
          }
        }
      })
    }

    return {
      removeAnswer,
    }
  },

}
</script>
